/*
 * @format
 */

import * as actionTypes from '../action-types';

export const initialState = {
  requestState: null,
};

export const awaitingZoneStatus = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_ZONES_PENDING:
      return {
        requestState: 'Pending',
      };

    case actionTypes.CLEAR_ZONES_PENDING:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
